import { memo } from "react";
import styled from "styled-components";

const StyledFieldset = styled.fieldset`
  width: ${(props) => (props.forlegend == "Y" ? `calc(100% - 62px)` : `auto`)};
  height: auto;
  margin: 0px 0px 20px 0px;
  padding: ${(props) => (props.forlegend == "Y" ? `25px 30px` : `0px`)};
  border: ${(props) => (props.forlegend == "Y" ? `1px solid #e1e1e1` : `0px`)};
  border-radius: 0px;
  position: relative;
  display: ${(props) => props.display || "flex"};
  flex-direction: row;
  align-items: center;
  @media (max-width: 600px) {
    display: block;
  }
  flex: 1;
`;

const StyledFieldset2 = styled.fieldset`
  flex: 1;
  display: ${(props) => props.display || "block"};
  width: ${(props) => (props.forlegend == "Y" ? `calc(100% - 62px)` : `auto`)};
  height: auto;
  margin: 0px 0px 20px 0px;
  padding: ${(props) => (props.forlegend == "Y" ? `25px 30px` : `0px`)};
  border: ${(props) => (props.forlegend == "Y" ? `1px solid #545454` : `0px`)};
  border-radius: 5px;
  position: relative;
  align-items: center;
  fieldset {
    width: 100%;
    max-width: 300px;
  }
`;

const Fieldset = memo(({ children, display = "flex", forlegend, ...rest }) => {
  return forlegend ? (
    <StyledFieldset
      {...rest}
      display={display}
      forlegend={forlegend ? "Y" : "N"}
    >
      {children}
    </StyledFieldset>
  ) : (
    <StyledFieldset2
      {...rest}
      display={display}
      forlegend={forlegend ? "Y" : "N"}
    >
      {children}
    </StyledFieldset2>
  );
});

export default Fieldset;
